import '../10. Battle/Library/LibraryBoxBattle.scss'
import NP from "../1. Core/NP";
import Control from "../1. Core/Control";
import ListGroupHeader from "../1. Core/Controls/ListBox/ListGroupHeader";
import Delegate from "../1. Core/Delegate";
import IconSelect from "../1. Core/Controls/Select/IconSelect";
import {
	getCountries,
	getStates,
	getTournaments,
	getWeights,
	getWeightString,
	ITournament,
	Weight
} from "../10. Battle/Util";
import {IState} from "./StatesList";
import {EventTournament, SportType} from "../10. Battle/types";
import Select from "../1. Core/Controls/Select/Select";
import {ServerAPI} from "../1. Core/ServerAPI";


export default class AthletesFilterPanel extends Control {

	public EvFilterSortChanged: Delegate;

	private _tournamentCombo: IconSelect;
	private _countryCombo: IconSelect;
	private _stateCombo: IconSelect;
	private _genderCombo: IconSelect;
	private _weightCombo: IconSelect;
	private _sortFieldCombo: IconSelect;
	private _sortDirectionCombo: IconSelect;
	private _TType: SportType;
	private _eventInput: Select;


	_initFields(settings: object)
	{
		this.EvFilterSortChanged = new Delegate();
		this._TType = SportType.MMA;
		super._initFields(settings);
	}

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="filter-panel"></div>');

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'Parameters',
			Class: 'app-list-group__subheader--accent'
		});

		this._tournamentCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Tournaments'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.event,
				Content: NP.RM.getString('AllTournaments')
			}],
			EvItemSelected: () =>
			{
				this.updateEvents();
				this._applyFiltersSort()
			}
		});

		this._eventInput = new Select({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Event'),
			EvItemSelected: () => this._applyFiltersSort()
		});

		let allItem = {
			Value: null as any,
			FontImage: NP.FontImages.geo,
			Content: NP.RM.getString('All')
		};

		this._countryCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Country'),
			SelectedIndex: 0,
			Items: [allItem],
			EvItemSelected: async () =>
			{
				let cntId = this._countryCombo.getValue()
				if (cntId)
				{
					let states = await getStates(cntId)

					if (this._stateCombo)
					{
						let items = states.map(state => ({
							Value: state.Id,
							FontImage: NP.FontImages.geo,
							Content: state.Name
						}));

						this._stateCombo.setItems([allItem, ...items]);
						this._stateCombo.setValue(null, false);
					}
				}
				else
				{
					this._stateCombo.setItems([allItem]);
				}
				this._applyFiltersSort()
			}
		});

		this._stateCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('State'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.geo,
				Content: NP.RM.getString('All')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._genderCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Gender'),
			SelectedIndex: 0,
			Items: [{
				Value: 'All',
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('All')
			}, {
				Value: 1,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('MaleGender')
			}, {
				Value: 0,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('FemaleGender')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._weightCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('WeightCategory'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.weight,
				Content: NP.RM.getString('All')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'OrderBy',
			Class: 'app-list-group__subheader--accent'
		});

		this._sortFieldCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: 'Id',
				FontImage: NP.FontImages.sort,
				Content: 'Id'
			},{
				Value: 'Name',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByName')
			}, {
				Value: 'Country',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('Country')
			}, {
				Value: 'Weight',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByWeight')
			}, {
				Value: 'BoutsCount',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('BoutsCount')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._sortDirectionCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: -1,
				FontImage: NP.FontImages.arrow_downward,
				Content: NP.RM.getString('Desc')
			}, {
				Value: 1,
				FontImage: NP.FontImages.arrow_upward,
				Content: NP.RM.getString('Asc')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._renderItems([this._root], this._ParentNode || document.documentElement);
		this._loadFilters();
	}

	async updateEvents()
	{
		if (!this._tournamentCombo.getValue())
			return;
		let response = await ServerAPI.callUiApi("/t-events", {
			Count: 500,
			Offset: 0,
			SportType: this._TType,
			TournamentId: this._tournamentCombo.getValue(),
			CalcCount: false
		}, 'POST') as { List: EventTournament[], AllCount: number };

		this._eventInput.setItems(response.List.map(ev => ({Content: ev.Name, Value: ev.Id})));
	}

	_loadFilters()
	{
		this.updateEvents();

		getWeights({Type: this._TType}).then((res: Weight[]) =>
		{
			let items = res.map(w => ({Value: w.Id, FontImage: NP.FontImages.weight, Content: getWeightString(w)}));
			this._weightCombo.addItems(items);
		});

		getTournaments(this._TType).then((res: ITournament[]) =>
		{
			if (this._tournamentCombo)
			{
				let items = res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name}));
				if (items.length == 1)
				{
					this._tournamentCombo.setItems(items);
					this._tournamentCombo.setValue(items[0].Value, false)
				}
				else
					this._tournamentCombo.addItems(items);
			}
		});

		getCountries(false).then((res: IState[]) =>
		{
			let items = res.map(state => ({Value: state.Id, FontImage: NP.FontImages.geo, Content: state.Name}));
			if (this._countryCombo)
				this._countryCombo.addItems(items);
		});
	}

	_applyFiltersSort()
	{
		this.EvFilterSortChanged.fire(this, this.getFilterData())
	}

	getFilterData()
	{
		return {
			CountryId: this._countryCombo.getValue(),
			StateId: this._stateCombo.getValue(),
			Sex: this._genderCombo.getValue() == 'All' ? null : this._genderCombo.getValue(),
			WeightCategory: this._weightCombo.getValue(),
			SortField: this._sortFieldCombo.getValue(),
			SortDirection: this._sortDirectionCombo.getValue(),
			TournamentId: this._tournamentCombo.getValue(),
			EventId: this._eventInput.getValue()
		}
	}

	setSortValues(sortField: string, sortDirection: number)
	{
		this._sortFieldCombo.setValue(sortField, false);
		this._sortDirectionCombo.setValue(sortDirection, false);
	}
}